<mat-accordion>
  <div *ngFor="let panel of expansionPanels" [ngClass]="panel.containerClass">
    <mat-expansion-panel #expansionPanel>
      <mat-expansion-panel-header
        class="u-padding-0-16"
        (click)="
          expansionPanel.expanded ? open(expansionPanel) : close(expansionPanel)
        "
      >
        <mat-panel-title [ngStyle]="{ 'flex-basis': '0' }">
          <app-form-template-title
            [text]="panel.title.text"
            [primaryIcon]="panel.title.primaryIcon"
            [secondaryIcon]="panel.title.secondaryIcon"
            class="u-display-block"
          >
          </app-form-template-title>
        </mat-panel-title>
        <mat-panel-description [ngStyle]="{ margin: '0', 'flex-basis': '0' }">
          <app-form-template-description
            [description]="panel?.description"
            class="u-width-100 u-display-block"
          >
          </app-form-template-description>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div
        [ngClass]="{ 'u-marginLeft-32': panel.title.primaryIcon }"
        class="u-paddingTop-24"
      >
        <ng-container *ngIf="panel.disableForms">
          <div class="u-marginBottom-24">
            <span
              i18n="@@settingsView.expansionPanel.disableFormsText"
              >{panel.disableFormsText, select,
                other {{{ panel.disableFormsText }}}

            }</span>
          </div>
        </ng-container>
        <app-form-template-body
          *ngIf="panel.forms && !panel.disableForms"
          [formGroup]="panel.formGroup"
          [forms]="panel.forms"
          (formChange)="formChange($event, panel)"
          class="u-display-block u-marginBottom-24 u-margin-0-8"
        >
        </app-form-template-body>
        <ng-container *ngIf="!panel.disableActionBar">
          <div
            fxLayout="row"
            fxLayoutAlign="end center"
            class="u-marginBottom-8"
          >
            <div class="u-marginRight-8">
              <button
                i18n="@@global.cancel"
                mat-button
                (click)="close(expansionPanel)"
              >
                Cancel
              </button>
            </div>
            <app-form-template-action-bar
              *ngIf="panel.actions"
              [actions]="panel.actions"
              (itemClicked)="actionClick($event, panel)"
              class="u-display-block"
            >
            </app-form-template-action-bar>
          </div>
        </ng-container>
      </div>
    </mat-expansion-panel>
  </div>
</mat-accordion>
